import Overlayable from "vuetify/lib/mixins/overlayable";
import VDialog from "vuetify/lib/components/VDialog";
import VNavigationDrawer from "vuetify/lib/components/VNavigationDrawer";

/**
 * Vuetify 2 Overlayable.shouldScroll walks el.parentNode looking for [data-app].
 * html.parentNode is Document, which has no hasAttribute — so a wheel event on
 * an open dialog (especially overscroll at top/bottom) throws:
 *   TypeError: el.hasAttribute is not a function
 * @see https://github.com/vuetifyjs/vuetify/issues/15977
 *
 * @param {{ options?: { methods?: { shouldScroll?: Function } } }} component
 */
function patchShouldScroll(component) {
    const methods = component && component.options && component.options.methods;
    if (!methods || typeof methods.shouldScroll !== "function") {
        return;
    }
    if (methods.shouldScroll._safeteePatched) {
        return;
    }

    const original = methods.shouldScroll;

    /**
     * @param {Node | null | undefined} el
     * @param {WheelEvent} e
     * @returns {boolean}
     */
    function shouldScroll(el, e) {
        if (
            !el ||
            el.nodeType !== Node.ELEMENT_NODE ||
            typeof el.hasAttribute !== "function"
        ) {
            return false;
        }
        return original.call(this, el, e);
    }
    shouldScroll._safeteePatched = true;
    methods.shouldScroll = shouldScroll;
}

patchShouldScroll(Overlayable);
patchShouldScroll(VDialog);
patchShouldScroll(VNavigationDrawer);
